import { useEffect } from "react";
import { ReactSortable } from "react-sortablejs";
import Select from "../../../../commonComponents/Select/Select";

const InclusionSelector = ({
  inclusionData,
  inputs,
  inputHandler,
  errors,
  formPlug,
  handleInputDelete,
  sortedInclusions,
  setSortedInclusions,
}) => {
  useEffect(() => {
    if (!inputs.inclusions || inputs.inclusions.length === 0) {
      setSortedInclusions([]);
      return;
    }
    setSortedInclusions((prevSorted) => {
      const prevIds = new Set(prevSorted.map((item) => item._id));
      const newIds = new Set(inputs.inclusions.map((item) => item._id));
      const ordered = prevSorted.filter((item) => newIds.has(item._id));
      const newItems = inputs.inclusions.filter(
        (item) => !prevIds.has(item._id)
      );
      return [...ordered, ...newItems];
    });
  }, [inputs.inclusions]);

  return (
    console.log(sortedInclusions),
    <div className="row">
      <div className="col-12 col-md-6">
        <Select
          title="Choose Inclusion"
          className="css-slc-esc1"
          placeholder="Select"
          options={inclusionData}
          labelSetter={(o) => o?.inclusion_name}
          valueSetter={(option) => option._id}
          field="inclusions"
          error={errors.inclusions}
          value={inputs.inclusions || []}
          onChange={inputHandler}
          inputSocket={formPlug}
          Multi2
        />
      </div>
      <div className="row">
        {
          sortedInclusions?.length != 0 ? 
          <ReactSortable
          key={sortedInclusions?.[0]?._id}
          list={sortedInclusions.map((item) => ({ ...item }))}
          setList={setSortedInclusions}
          animation={200}
          delayOnTouchStart
          delay={2}
          className="selectedIllusionListData"
        >
          {sortedInclusions.map((option) => (
            <div
              key={option._id}
              data-id={option._id}
              className="mb-1 draggable-item"
            >
              <div className="d-inline-block mb-1">
                <button className="selected__item" type="button">
                  {option.inclusion_name}
                  <img
                    src="/assets/img/icons/close-red.svg"
                    onClick={() => handleInputDelete(option._id, "inclusions")}
                    alt=""
                  />
                </button>
              </div>
            </div>
          ))}
        </ReactSortable> : ''
        }
        
      </div>
    </div>
  );
};

export default InclusionSelector;
